import React, {Dispatch, useEffect, useState } from 'react'
import {Audio, Loader, Toast} from '@kaleyra/emmy'
import cn from 'classnames'
import { useTranslation } from 'react-i18next'
import Styles from './viewRecording.module.scss'
import { isEmpty } from 'lodash'
import moment from 'moment'
import { Tooltip, Slider } from '@kaleyra/emmy';
import { limitStringLength, validateOnlyNumbers } from '../../../../utils';
import {useDispatch} from "react-redux";
import {
	markAsRead
} from '../../../../store/actions/voicemail.action';


export type MapStateToPropsType = {
    params:any,
    data:any,
    inProgress:boolean
}
export type MapDispatchToPropsType = {
    closeModal : () => void,
    removeInstance: ()=> void,
}
const VoicemailViewRecording : React.FC<MapDispatchToPropsType & MapStateToPropsType> = (
    {
        params,
        data,
        inProgress,
        closeModal,
        removeInstance,
    }
) => {
    const [soundType, setSoundType] = useState('')
    const [selectedSound, setSelectedSound] = useState<any>({})
    // const { callRecordsError, callRecordsErrorMsg } = useSelector((state: IStateType) => state.callRecords);
    const { t } = useTranslation()
    const modalData = params;
    const dispatch: Dispatch<any> = useDispatch();
    const [soundData, setSoundData] = useState({
        filePath: '',
        duration: 0,
        soundId: 0,
        fileName: '',
        durationInFormat: ''
    });

    useEffect(() => {
        if (modalData.play_status == false) {
            const formatApplyPayload = {
                data: [
                    {
                        recording_id: modalData.recording_id,
                        parent_id:modalData.call_id,
                        read: "true"
                    }
                ],
                update_ids: [modalData.recording_id]
            }

            dispatch(markAsRead(formatApplyPayload, (message: string, status: boolean) => {
                if (status) {
                    // sucess message not need here so commenting for now
                    // Toast(message, 'success');
                } else {
                    Toast(message, 'error');
                }
            }));

            return (() => {
                removeInstance();
            })
        }
    }, [modalData])

    useEffect(() => {
        if (!isEmpty(data)) {
            const keys = Object.keys(data);
            const updatedSoundData = {
                filePath         : data[keys[0]] || '',
                duration         : data[keys[1]] ||  0,
                soundId          : data[keys[2]] ||  0,
                fileName         : data[keys[6]] || '',
                durationInFormat : data[keys[7]] || '',
            };
    
            setSoundType(keys[0]); 
            setSelectedSound(data[keys[0]]);
            setSoundData(updatedSoundData);
        }
    }, [data]);

    const callDetails = [
        {
            key: t("mainType"),
            value: modalData && modalData.call_type || '-'
        },
        {
            key: t("callFrom"),
            value: modalData && `${modalData.call_from}` || '-',
            type: 'call_from'
        },
        {
            key: t("KLR00928"),
            value: modalData && `${modalData.call_to}` || '-',
            type: 'call_to'
        },
        {
            key: t("KLR00926"),
            value: modalData && moment.unix(modalData.created_at).format(
                'Do MMM YYYY, hh:mm:ss A'
            ) || '-'
        }
    ]

    return (
        <Slider
            title={t('KLR00923')}
            containerId="root-modal"
            onClose={() => closeModal()}
            visibility={true}
        >
            <div className={Styles.viewSound}>
                {inProgress && <Loader />}
                {
                    !inProgress && !isEmpty(data) &&
                    <>

                        <div>
                            <div className={Styles.audioDesc}>
                                <span className={cn(Styles.ntitle, Styles.key)}>{t('camCreatedOn')}</span>
                                <span className={cn(Styles.ndesc, Styles.val)}>
                                    {moment(selectedSound.created_at).format('DD MMM YYYY')}
                                </span>
                            </div>
                            <div className={Styles.audioDesc}>
                                <span className={cn(Styles.ntitle, Styles.key)}>{t('mainDuration')}</span>
                                <span className={cn(Styles.ndesc, Styles.val)}>{soundData.durationInFormat}</span>
                            </div>
                        </div>

                        <div className={Styles.audio}>
                            {
                                    <span>
										<Audio
                                            filePath={soundData.filePath}
                                            soundDuration={soundData.duration}
                                            soundId={soundData.soundId}
                                            key={soundData.soundId}
                                        />
									</span>
                            }
                            <span className={Styles.audioTitle}>
								<span className={Styles.ntitle}>{t('fileName')}</span>
								<span className={Styles.ndesc}>{soundData.fileName}</span>
							</span>
                        </div>

                        <div>
                            <div className={cn(Styles.audioDesc, Styles.title)}>{t("callDetails")}</div>
                            {
                                callDetails.map((item, index) => {
                                    return (
                                        <div className={Styles.audioDesc} key={index}>
                                            <span className={cn(Styles.ntitle, Styles.key)}>{item.key}</span>

                                            {(item.type === 'call_to' || item.type === 'call_from')?

                                                <>
                                                    {item.value?.length > 32 ? (
                                                            <Tooltip
                                                                title={
                                                                    <div className={Styles.tpClass}>
                                                                        {item.value}
                                                                    </div>
                                                                }
                                                                trigger={'hover'}
                                                                placement="bottomLeft"
                                                                color="#212B36"
                                                            >
															<span className={cn(Styles.ndesc, Styles.val)}>
																{limitStringLength(
                                                                    (validateOnlyNumbers(item.value)) ? `+${item.value}` : item.value,
                                                                    32)
                                                                }
															</span>
                                                            </Tooltip>
                                                        ) :
                                                        <>

															<span className={cn(Styles.ndesc, Styles.val)}>
																{(validateOnlyNumbers(item.value)) ? `+${item.value}` : item.value}
															</span>

                                                        </>
                                                    }
                                                </> :
                                                <span className={cn(Styles.ndesc, Styles.val)}>
													{item.value}
												</span>
                                            }
                                        </div>
                                    )
                                })
                            }

                        </div>
                    </>
                }
            </div>
        </Slider>
    )
}

export default VoicemailViewRecording